<div class="d-flex justify-content-center align-items-center vh-100">
    <span class="btn btn-success">Loading ...</span>
</div>